import OtpTable from "./otpTable.container";

export default OtpTable;